import { NgModule } from '@angular/core';
import { ContactsSearchButtonPipe } from './contacts-search-button.pipe';

@NgModule({
    declarations: [
        ContactsSearchButtonPipe
    ],
    exports: [
        ContactsSearchButtonPipe
    ]
})
export class ContactsSearchButtonModule { }